var map = {
	"./account-ico-mail.svg": 785,
	"./account-ico-pass.svg": 786,
	"./account-ico-phone.svg": 787,
	"./bank-transfer.svg": 788,
	"./betnearn-ico.svg": 789,
	"./birthday-bonus-ico.svg": 790,
	"./birthday.webp": 1818,
	"./bonus-code-ico.svg": 791,
	"./bonus-ico.svg": 792,
	"./bonus-received-ico.svg": 793,
	"./bonus.webp": 1819,
	"./business-account-upgrade-ico.svg": 794,
	"./check-in-daily-ico.svg": 795,
	"./checked.svg": 796,
	"./cloud-pointer.svg": 797,
	"./crypto.svg": 798,
	"./daily-bonus-ico.svg": 799,
	"./daily-limit.webp": 1820,
	"./deposit-delay-bonus-ico.svg": 800,
	"./e-wallet.svg": 801,
	"./earn-coin-ico.svg": 802,
	"./earn-x33-coin-ico.svg": 803,
	"./email.svg": 804,
	"./facebook.svg": 805,
	"./feedback.svg": 806,
	"./first-bet-ico.svg": 807,
	"./games-rebate-ico.svg": 808,
	"./info.svg": 809,
	"./instagram.svg": 810,
	"./live-casino-rebate-ico.svg": 811,
	"./lucky-spin-ico.svg": 812,
	"./messenger.svg": 813,
	"./mobile-app-deposit-ico.svg": 814,
	"./monthly-cash.webp": 1821,
	"./msg-activity.svg": 815,
	"./msg-ann.svg": 816,
	"./msg-notice.svg": 817,
	"./new-icon.svg": 818,
	"./people-ico.svg": 819,
	"./quick-pay.svg": 820,
	"./r77-coin.svg": 821,
	"./rescue-bonus-ico.svg": 822,
	"./rescue-lc-ico.svg": 823,
	"./rescue-slots-ico.svg": 824,
	"./return.svg": 825,
	"./sc-bc-active-ico.svg": 826,
	"./sc-bc-ico.svg": 827,
	"./sc-bi-active-ico.svg": 828,
	"./sc-bi-ico.svg": 829,
	"./sc-mail-active-ico.svg": 830,
	"./sc-mail-ico.svg": 831,
	"./sc-mp-active-ico.svg": 832,
	"./sc-mp-ico.svg": 833,
	"./sc-pin-active-ico.svg": 834,
	"./sc-pin-ico.svg": 835,
	"./slots-rebate-ico.svg": 836,
	"./sports-rebate-ico.svg": 837,
	"./telegram.svg": 838,
	"./twitter.svg": 839,
	"./vip-up-level-ico.svg": 840,
	"./vip-weekly-bonus.svg": 841,
	"./wallet-ico.svg": 842,
	"./weekly-tournament-ico.svg": 843,
	"./welcome-bonus-ico.svg": 844,
	"./whatsapp.svg": 845,
	"./withdrawal-delay-bonus-ico.svg": 846,
	"./withdrawal.webp": 1822,
	"./x33-coin.svg": 847
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 849;